import { Component, OnInit, Input, signal, OnDestroy, input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { APIService } from '../../shared/api.service';
import { Asset } from '../../classes/asset';
import { Gateway } from '../../classes/gateway';
import { StoreService } from '../../shared/store.service';
import { Report } from '../../classes/reports/report';
import { ReportConfig } from '../../classes/reports/report-config';
import { SelectedAsset } from '../../classes/rule-service/selected-asset';
import { filter } from 'rxjs/operators';
import { AssetService } from 'app/shared/asset.service';
import { ICalendarDay } from 'app/layout/calendar/calendar.component';
import moment from 'moment';
import { ReportService } from 'app/shared/report.service';

@Component({
  selector: 'app-report-configure',
  templateUrl: './report-configure.component.html',
  styleUrls: ['./report-configure.component.css'],
  standalone: false
})
export class ReportConfigureComponent implements OnInit, OnDestroy {

  report = signal<Report>(null);
  tabIndex = signal<number>(0);
  gateways = signal<Gateway[]>(null);
  can = signal<{ selectCollections: boolean }>({ selectCollections: false });
  collections = signal<any[]>(null);

  formValid: boolean;
  reportConfig = signal<ReportConfig>(new ReportConfig());
  startAt: Date;
  // The asset seelcted by the user in asset picker
  selectedAsset: SelectedAsset;
  selectedCount = signal<number>(0);
  reportAllGateways: boolean = false;
  runReport = signal<boolean>(false);
  en: any;

  reportsRunning: boolean;

  collection = signal<{ report: Report, reportConfig: ReportConfig }[]>([]);
  reportTabIndex = signal<number>(0);

  dateFormat = 'dd MMMM yyyy';

  constructor(private assetService: AssetService, private reportService: ReportService, private storeService: StoreService, private apiService: APIService, private route: ActivatedRoute, private router: Router) {

    // this.tabIndex.set(+(localStorage.getItem('reports:defaultTab') || 0));


    storeService.sectionBannerBack
      .pipe(filter(sbb => !!sbb && sbb.state === true && sbb.section === 'reports'))
      .subscribe(state => {
        // Set to handled
        state.state = false;
        this.storeService.setSectionBannerBack(state);
        if (this.runReport) {
          this.runReport = null;
        } else {
          this.router.navigate(['/reports']);
        }
      });
  }

  ngOnDestroy(): void {
    localStorage.setItem('reports:defaultTab', `${this.tabIndex()}`);
  }

  monthChange(property, date: Date) {
    console.log(property, date);
    this[property] = date;
    if (property === 'startAt') {

      switch (this.report().dateSpan) {
        case 'week':
          date = this.getMonday(date);
          break;
      }
      this.reportConfig().startAt = date;
    }
  }

  calendarChange(property, date: ICalendarDay) {
    console.log(property, date);
    this[property] = date.date;

    if (property === 'startAt') {

      switch (this.report().dateSpan) {
        case 'week':
          date.date = this.getMonday(date.date);
          break;
      }
      this.reportConfig().startAt = date.date;
    }
  }

  sortGateways() {

  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.reportService.getReport(params['reportid']).then(
        (report) => {
          this.report.set(report);
          this.dateFormat = this.report().dateSpan === 'month' ? 'MMMM yyyy' : 'dd MMMM yyyy';
          console.log(`REPORT`, this.report());
          this.can.update(c => {
            // Collection capable?
            c.selectCollections = this.report().blocks.some(b => b.fragment_id === 14);

            return c;
          });
          // Report is restricted to a specific asset type
          if (this.report().forAssetType) {
            // Check for one of the type - default to the asset if only one.
            this.storeService.assets.subscribe((assets) => {
              for (let item of assets) {
                if (this.selectedAsset.asset && item.assetType_id === this.report().forAssetType) {
                  // Already exists - clear it
                  this.selectedAsset.asset = new Asset();
                } else if (item.assetType_id === this.report().forAssetType) {
                  this.selectedAsset.asset = item;
                }
              }
            });
          }
          if (this.report().forGateway) {
            this.apiService.getGateways(this.report().forGatewayType > 0 ? this.report().forGatewayType : null)
              .then((gateways) => {
                this.gateways.set(gateways);
              });
          }
        }
      );

      this.reportConfig().startAt = this.getMonday();
    });

    this.en = {
      firstDayOfWeek: 1,
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    };

    this.selectedAsset = new SelectedAsset();
  }

  runReportClick() {
    if ((this.selectedCount() === 0 && !this.reportAllGateways) || !this.reportConfig().startAt) {
      return;
    }

    this.collection.set([]);
    this.setReportTabIndex(0);
    if (this.reportAllGateways) {
      // Ensure no gateways are selected if all required.
      if (this.tabIndex() === 0) {
        this.reportConfig().forGateways = this.gateways();
      } else {
        this.reportConfig().forGateways = this.getFavs();
      }
    } else {
      this.reportConfig().forGateways = this.gateways().filter(g => g.selected);
    }
    //this.reportConfig().forCollections = this.collections().filter(c => c.selected);
    this.reportConfig().forCollections = this.report().collections.filter(c => c.selected).map(c => c.id);
    this.reportConfig().collections = this.report().collections.filter(c => c.selected);
    this.startAt = moment(this.reportConfig().startAt).toDate();
    this.reportConfig().forAsset = this.selectedAsset.asset;
    this.reportConfig().forOrg = this.apiService.getUserOrg().id;
    this.collection.update(c => {
      c.push({ report: this.report(), reportConfig: this.reportConfig() });

      return c;
    });

    this.reportConfig().setTabTitle(this.report());

    this.runReport.set(true);
    this.apiService.postRoute(`/reports/${this.report().id}/generate`);
  }

  getFavs(): Gateway[] {
    try {
      const favs = JSON.parse(localStorage.getItem('gateways:favs') || '{}');
      return this.gateways().filter(gateway => !!favs[gateway.id]);
    } catch (e) {
      return [];
    }
  }

  collectionSelectChanged(selected: boolean) {
    console.log(selected);
    this.calcSelectedCount();
  }

  getDateFormat() {
    return this.apiService.getDateFormat();
  }

  reportStartAt(days: number): void {
    if (this.reportsRunning) {
      return;
    }

    let newConfig = new ReportConfig();
    newConfig.startAt = new Date(this.reportConfig().startAt);
    newConfig.forAsset = this.reportConfig().forAsset;
    newConfig.forGateways = this.reportConfig().forGateways;
    newConfig.forCollections = this.reportConfig().forCollections;

    let newReport = new Report(this.report());

    switch (this.report().dateSpan) {
      case 'week':
        newConfig.startAt.setDate(newConfig.startAt.getDate() + days);
        this.dateFormat = 'dd MMMM yyy';
        break;
      case 'month':
        newConfig.startAt.setMonth(newConfig.startAt.getMonth() + days);
        this.dateFormat = 'MMMM yyy';
        break;
    }

    this.startAt = moment(this.reportConfig().startAt).toDate();

    newConfig.setTabTitle(this.report());

    for (let index = 0; index < this.collection().length; index++) {
      const element = this.collection()[index];
      if (element.reportConfig.tabTitle === newConfig.tabTitle) {
        this.setReportTabIndex(index);
        return;
      }
    }
    // Check if the tab exists.

    this.reportsRunning = true;
    this.collection.update(c => {
      c.push({ report: newReport, reportConfig: newConfig });

      return c;
    });

    this.reportConfig.set(newConfig);
    this.runReport.set(true);

    setTimeout(() => {
      this.setReportTabIndex(this.collection().length - 1);
    }, 10);
  }

  getMonday(d = new Date) {
    let day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday

    return new Date(d.setDate(diff));
  }

  hasLoaded() {
    this.reportsRunning = false;
  }

  gatewayToggle(gateway) {
    this.gateways().find(gw => gw.id === gateway.id).selected = gateway.selected;
    this.calcSelectedCount();
  }

  calcSelectedCount() {
    const gatewayCount = this.gateways() ? this.gateways().filter(gw => gw.selected).length : 0;
    const collectionCount = this.report().collections ? this.report().collections.filter(c => c.selected).length : 0;
    this.selectedCount.set(gatewayCount + collectionCount);
  }

  setReportTabIndex(index: number) {
    this.reportTabIndex.set(index);

    console.log(`setReportTabIndex(${index})`);
  }

  setReportTab(tab) {
    console.log(tab);
  }

}
